import HomePageContentAPICall from "src/service/HomePageContentAPICall";
import BaseRepository from "./BaseRepository";
import Constants from "src/support/Constants";
import System from "src/helper/system";
const { homePageAllTabs } = Constants;

class HomePageContentRepository extends BaseRepository {
    getContentTabCount = async (searchParam) => {
        return await new HomePageContentAPICall().getContentTabCount({ searchParam })
    };
    getAllTabsCount = async (searchParam) => {
        return await new HomePageContentAPICall().getAllTabsCount(searchParam)
    };

    // NEW - DT
    getHomePageContent = async (params) => {
        let res = await new HomePageContentAPICall().getHomePageContent(params);
        let data = []
        if (res?.data?.webContentView) {
            res.data.webContentView = res.data.webContentView.map(item => {
                if (item.url) {
                    if (params.contentType !== homePageAllTabs.VIDEO.contentType && item.avnPageType !== homePageAllTabs.VIDEO.pageType) {
                        item.url = System.getRedirectionURL(item.url.replace(/^https?:\/\/[^\/]+/, ''));
                    } else {
                        item.url = item.url.replace(/^http:\/\//i, 'https://');
                    }
                }

                return item;
            });
        }
        data[params.contentType] = res?.data
        return data
    };
}

export default HomePageContentRepository;